<template>
  <div>
    <v-row
      v-if="!isLoading"
      class="main--text"
      justify=center>
      <v-col
        cols=12
        md=8
        sm=10
        >
        <v-card>
          <v-container
            fluid>
            <v-row
              no-gutters
              align=center>
              <h3>お支払い情報</h3>
            </v-row>
            <v-row
              no-gutters>
              <v-col>
                <v-list
                  two-line>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        カード番号
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ creditCard.number }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        タイプ
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ creditCard.type }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        有効期限
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ creditCard.expireDate() }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-btn
              rounded
              depressed
              outlined
              color="primary"
              @click="$emit('ok-button-click')">OK</v-btn>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-loading
      v-else/>
  </div>
</template>

<script>
import { getCreditCard } from '@/core/paypal'
import Loading from '@/components/organisms/Loading.vue'

export default {
  components: {
    "VLoading": Loading
  },
  model: {
    prop: 'cardId',
    event: 'input'
  },
  props: {
    cardId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      creditCard: null,
      isLoading: true
    }
  },
  async created () {
    this.creditCard = await getCreditCard(this.cardId)
    this.isLoading = false
  }
}
</script>
